'use strict';

var cov_2l9qebrzd7 = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\project\\projectCtrl.js',
      hash = '48bc0a6dd3a8a1872ec0894121646e4e2a7a245f',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\project\\projectCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 326,
          column: 3
        }
      },
      '1': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 7,
          column: 5
        }
      },
      '2': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 10,
          column: 3
        }
      },
      '3': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 11
        }
      },
      '4': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 27
        }
      },
      '5': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 25
        }
      },
      '6': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 54,
          column: 4
        }
      },
      '7': {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      },
      '8': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 67,
          column: 4
        }
      },
      '9': {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 115,
          column: 4
        }
      },
      '10': {
        start: {
          line: 69,
          column: 17
        },
        end: {
          line: 69,
          column: 31
        }
      },
      '11': {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 28
        }
      },
      '12': {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 114,
          column: 7
        }
      },
      '13': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 99,
          column: 7
        }
      },
      '14': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 96
        }
      },
      '15': {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 72
        }
      },
      '16': {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 42
        }
      },
      '17': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 72
        }
      },
      '18': {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 77
        }
      },
      '19': {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 71
        }
      },
      '20': {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 29
        }
      },
      '21': {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 82,
          column: 9
        }
      },
      '22': {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 90
        }
      },
      '23': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 85,
          column: 9
        }
      },
      '24': {
        start: {
          line: 84,
          column: 10
        },
        end: {
          line: 84,
          column: 31
        }
      },
      '25': {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 98,
          column: 10
        }
      },
      '26': {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 31
        }
      },
      '27': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 33
        }
      },
      '28': {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      '29': {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 108,
          column: 9
        }
      },
      '30': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 107,
          column: 11
        }
      },
      '31': {
        start: {
          line: 106,
          column: 12
        },
        end: {
          line: 106,
          column: 40
        }
      },
      '32': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 111,
          column: 9
        }
      },
      '33': {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 110,
          column: 58
        }
      },
      '34': {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 28
        }
      },
      '35': {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 27
        }
      },
      '36': {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 120,
          column: 4
        }
      },
      '37': {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 26
        }
      },
      '38': {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 25
        }
      },
      '39': {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 173,
          column: 4
        }
      },
      '40': {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      },
      '41': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 26
        }
      },
      '42': {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 13
        }
      },
      '43': {
        start: {
          line: 126,
          column: 16
        },
        end: {
          line: 126,
          column: 18
        }
      },
      '44': {
        start: {
          line: 127,
          column: 25
        },
        end: {
          line: 149,
          column: 5
        }
      },
      '45': {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 30
        }
      },
      '46': {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      '47': {
        start: {
          line: 152,
          column: 19
        },
        end: {
          line: 152,
          column: 41
        }
      },
      '48': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 160,
          column: 7
        }
      },
      '49': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 159,
          column: 9
        }
      },
      '50': {
        start: {
          line: 156,
          column: 10
        },
        end: {
          line: 156,
          column: 20
        }
      },
      '51': {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 35
        }
      },
      '52': {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 17
        }
      },
      '53': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      '54': {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 163,
          column: 13
        }
      },
      '55': {
        start: {
          line: 165,
          column: 19
        },
        end: {
          line: 165,
          column: 51
        }
      },
      '56': {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 28
        }
      },
      '57': {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 172,
          column: 7
        }
      },
      '58': {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 169,
          column: 22
        }
      },
      '59': {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 80
        }
      },
      '60': {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 171,
          column: 22
        }
      },
      '61': {
        start: {
          line: 174,
          column: 2
        },
        end: {
          line: 237,
          column: 4
        }
      },
      '62': {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 30
        }
      },
      '63': {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 24
        }
      },
      '64': {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 200,
          column: 6
        }
      },
      '65': {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 235,
          column: 5
        }
      },
      '66': {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 234,
          column: 7
        }
      },
      '67': {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 233,
          column: 9
        }
      },
      '68': {
        start: {
          line: 205,
          column: 23
        },
        end: {
          line: 205,
          column: 45
        }
      },
      '69': {
        start: {
          line: 206,
          column: 10
        },
        end: {
          line: 232,
          column: 11
        }
      },
      '70': {
        start: {
          line: 207,
          column: 12
        },
        end: {
          line: 207,
          column: 33
        }
      },
      '71': {
        start: {
          line: 208,
          column: 12
        },
        end: {
          line: 230,
          column: 14
        }
      },
      '72': {
        start: {
          line: 231,
          column: 12
        },
        end: {
          line: 231,
          column: 18
        }
      },
      '73': {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 50
        }
      },
      '74': {
        start: {
          line: 239,
          column: 2
        },
        end: {
          line: 284,
          column: 4
        }
      },
      '75': {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 283,
          column: 7
        }
      },
      '76': {
        start: {
          line: 251,
          column: 6
        },
        end: {
          line: 253,
          column: 7
        }
      },
      '77': {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 15
        }
      },
      '78': {
        start: {
          line: 254,
          column: 6
        },
        end: {
          line: 254,
          column: 30
        }
      },
      '79': {
        start: {
          line: 255,
          column: 27
        },
        end: {
          line: 271,
          column: 7
        }
      },
      '80': {
        start: {
          line: 272,
          column: 6
        },
        end: {
          line: 282,
          column: 9
        }
      },
      '81': {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 280,
          column: 9
        }
      },
      '82': {
        start: {
          line: 274,
          column: 10
        },
        end: {
          line: 277,
          column: 13
        }
      },
      '83': {
        start: {
          line: 278,
          column: 10
        },
        end: {
          line: 278,
          column: 35
        }
      },
      '84': {
        start: {
          line: 279,
          column: 10
        },
        end: {
          line: 279,
          column: 17
        }
      },
      '85': {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 24
        }
      },
      '86': {
        start: {
          line: 285,
          column: 2
        },
        end: {
          line: 305,
          column: 4
        }
      },
      '87': {
        start: {
          line: 286,
          column: 25
        },
        end: {
          line: 286,
          column: 29
        }
      },
      '88': {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 292,
          column: 5
        }
      },
      '89': {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 291,
          column: 7
        }
      },
      '90': {
        start: {
          line: 289,
          column: 8
        },
        end: {
          line: 289,
          column: 48
        }
      },
      '91': {
        start: {
          line: 290,
          column: 8
        },
        end: {
          line: 290,
          column: 14
        }
      },
      '92': {
        start: {
          line: 293,
          column: 4
        },
        end: {
          line: 304,
          column: 7
        }
      },
      '93': {
        start: {
          line: 294,
          column: 6
        },
        end: {
          line: 300,
          column: 9
        }
      },
      '94': {
        start: {
          line: 301,
          column: 6
        },
        end: {
          line: 301,
          column: 34
        }
      },
      '95': {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 303,
          column: 49
        }
      },
      '96': {
        start: {
          line: 306,
          column: 19
        },
        end: {
          line: 310,
          column: 4
        }
      },
      '97': {
        start: {
          line: 311,
          column: 2
        },
        end: {
          line: 315,
          column: 4
        }
      },
      '98': {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 54
        }
      },
      '99': {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 28
        }
      },
      '100': {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 314,
          column: 22
        }
      },
      '101': {
        start: {
          line: 316,
          column: 2
        },
        end: {
          line: 324,
          column: 4
        }
      },
      '102': {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 322,
          column: 5
        }
      },
      '103': {
        start: {
          line: 318,
          column: 6
        },
        end: {
          line: 321,
          column: 7
        }
      },
      '104': {
        start: {
          line: 319,
          column: 8
        },
        end: {
          line: 319,
          column: 86
        }
      },
      '105': {
        start: {
          line: 320,
          column: 8
        },
        end: {
          line: 320,
          column: 14
        }
      },
      '106': {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 323,
          column: 29
        }
      },
      '107': {
        start: {
          line: 325,
          column: 2
        },
        end: {
          line: 325,
          column: 18
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 48
          },
          end: {
            line: 4,
            column: 49
          }
        },
        loc: {
          start: {
            line: 4,
            column: 204
          },
          end: {
            line: 326,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 37
          },
          end: {
            line: 5,
            column: 38
          }
        },
        loc: {
          start: {
            line: 5,
            column: 43
          },
          end: {
            line: 7,
            column: 3
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 68,
            column: 18
          },
          end: {
            line: 68,
            column: 19
          }
        },
        loc: {
          start: {
            line: 68,
            column: 30
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 68
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 71,
            column: 51
          },
          end: {
            line: 71,
            column: 52
          }
        },
        loc: {
          start: {
            line: 71,
            column: 59
          },
          end: {
            line: 114,
            column: 5
          }
        },
        line: 71
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 117,
            column: 18
          },
          end: {
            line: 117,
            column: 19
          }
        },
        loc: {
          start: {
            line: 117,
            column: 30
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 117
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 121,
            column: 20
          },
          end: {
            line: 121,
            column: 21
          }
        },
        loc: {
          start: {
            line: 121,
            column: 32
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 121
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 168,
            column: 102
          },
          end: {
            line: 168,
            column: 103
          }
        },
        loc: {
          start: {
            line: 168,
            column: 110
          },
          end: {
            line: 172,
            column: 5
          }
        },
        line: 168
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 174,
            column: 16
          },
          end: {
            line: 174,
            column: 17
          }
        },
        loc: {
          start: {
            line: 174,
            column: 30
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 174
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 239,
            column: 22
          },
          end: {
            line: 239,
            column: 23
          }
        },
        loc: {
          start: {
            line: 239,
            column: 38
          },
          end: {
            line: 284,
            column: 3
          }
        },
        line: 239
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 250,
            column: 7
          },
          end: {
            line: 250,
            column: 8
          }
        },
        loc: {
          start: {
            line: 250,
            column: 20
          },
          end: {
            line: 283,
            column: 5
          }
        },
        line: 250
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 272,
            column: 95
          },
          end: {
            line: 272,
            column: 96
          }
        },
        loc: {
          start: {
            line: 272,
            column: 103
          },
          end: {
            line: 282,
            column: 7
          }
        },
        line: 272
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 285,
            column: 18
          },
          end: {
            line: 285,
            column: 19
          }
        },
        loc: {
          start: {
            line: 285,
            column: 33
          },
          end: {
            line: 305,
            column: 3
          }
        },
        line: 285
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 293,
            column: 72
          },
          end: {
            line: 293,
            column: 73
          }
        },
        loc: {
          start: {
            line: 293,
            column: 80
          },
          end: {
            line: 304,
            column: 5
          }
        },
        line: 293
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 311,
            column: 31
          },
          end: {
            line: 311,
            column: 32
          }
        },
        loc: {
          start: {
            line: 311,
            column: 66
          },
          end: {
            line: 315,
            column: 3
          }
        },
        line: 311
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 316,
            column: 27
          },
          end: {
            line: 316,
            column: 28
          }
        },
        loc: {
          start: {
            line: 316,
            column: 74
          },
          end: {
            line: 324,
            column: 3
          }
        },
        line: 316
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        }, {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        }],
        line: 8
      },
      '1': {
        loc: {
          start: {
            line: 77,
            column: 43
          },
          end: {
            line: 77,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 77,
            column: 43
          },
          end: {
            line: 77,
            column: 62
          }
        }, {
          start: {
            line: 77,
            column: 66
          },
          end: {
            line: 77,
            column: 75
          }
        }],
        line: 77
      },
      '2': {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }, {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }],
        line: 80
      },
      '3': {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }, {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }],
        line: 83
      },
      '4': {
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }],
        line: 103
      },
      '5': {
        loc: {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        }, {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 11
          }
        }],
        line: 105
      },
      '6': {
        loc: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        }, {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        }],
        line: 109
      },
      '7': {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }],
        line: 122
      },
      '8': {
        loc: {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        }],
        line: 153
      },
      '9': {
        loc: {
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 159,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 159,
            column: 9
          }
        }, {
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 159,
            column: 9
          }
        }],
        line: 155
      },
      '10': {
        loc: {
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 155,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 155,
            column: 38
          }
        }, {
          start: {
            line: 155,
            column: 42
          },
          end: {
            line: 155,
            column: 80
          }
        }],
        line: 155
      },
      '11': {
        loc: {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }, {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }],
        line: 162
      },
      '12': {
        loc: {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 235,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 235,
            column: 5
          }
        }, {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 235,
            column: 5
          }
        }],
        line: 202
      },
      '13': {
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 233,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 233,
            column: 9
          }
        }, {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 233,
            column: 9
          }
        }],
        line: 204
      },
      '14': {
        loc: {
          start: {
            line: 206,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 206,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        }, {
          start: {
            line: 206,
            column: 10
          },
          end: {
            line: 232,
            column: 11
          }
        }],
        line: 206
      },
      '15': {
        loc: {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 7
          }
        }, {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 7
          }
        }],
        line: 251
      },
      '16': {
        loc: {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        }, {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 280,
            column: 9
          }
        }],
        line: 273
      },
      '17': {
        loc: {
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 291,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 291,
            column: 7
          }
        }, {
          start: {
            line: 288,
            column: 6
          },
          end: {
            line: 291,
            column: 7
          }
        }],
        line: 288
      },
      '18': {
        loc: {
          start: {
            line: 318,
            column: 6
          },
          end: {
            line: 321,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 318,
            column: 6
          },
          end: {
            line: 321,
            column: 7
          }
        }, {
          start: {
            line: 318,
            column: 6
          },
          end: {
            line: 321,
            column: 7
          }
        }],
        line: 318
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2l9qebrzd7.s[0]++;
/**
 * MainCtrl - controller
 */
angular.module('app').controller('ProjectCtrl', function ($scope, $deltaclearData, SweetAlert, $rootScope, $deltadate, $translate, $CRUDService, $otherHttpService, $deltahttp, $location, $filter, FileUploader) {
  cov_2l9qebrzd7.f[0]++;
  cov_2l9qebrzd7.s[1]++;

  $rootScope.processPageRight('1_1', function () {
    cov_2l9qebrzd7.f[1]++;
  });
  cov_2l9qebrzd7.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_2l9qebrzd7.b[0][0]++;
    cov_2l9qebrzd7.s[3]++;

    return;
  } else {
    cov_2l9qebrzd7.b[0][1]++;
  }

  cov_2l9qebrzd7.s[4]++;
  $scope.listProjects = [];
  cov_2l9qebrzd7.s[5]++;
  $scope.PATH = 'Projet';
  cov_2l9qebrzd7.s[6]++;
  $scope.contries = [{ id: '1', name: 'Afghanistan' }, { id: '2', name: 'Afrique du Sud' }, { id: '3', name: 'Albanie' }, { id: '4', name: 'Algérie' }, { id: '5', name: 'Allemagne' }, { id: '6', name: 'Andorre' }, { id: '7', name: 'Angola' }, { id: '8', name: 'Antigua-et-Barbuda' }, { id: '9', name: 'Arabie saoudite' }, { id: '10', name: 'Argentine' }, { id: '11', name: 'Arménie' }, { id: '12', name: 'Australie' }, { id: '13', name: 'Autriche' }, { id: '14', name: 'Azerbaïdjan' }, { id: '15', name: 'Bahamas' }, { id: '16', name: 'Bahreïn' }, { id: '17', name: 'Bangladesh' }, { id: '18', name: 'Barbade' }, { id: '19', name: 'Belgique' }, { id: '20', name: 'Belize' }, { id: '21', name: 'Bénin' }, { id: '22', name: 'Bhoutan' }, { id: '23', name: 'Biélorussie' }, { id: '24', name: 'Birmanie' }, { id: '25', name: 'Bolivie' }, { id: '26', name: 'Bosnie-Herzégovine' }, { id: '27', name: 'Botswana' }, { id: '28', name: 'Brésil' }, { id: '29', name: 'Brunei' }, { id: '30', name: 'Bulgarie' }, { id: '31', name: 'Burkina Faso' }, { id: '32', name: 'Burundi' }, { id: '33', name: 'Cambodge' }, { id: '34', name: 'Cameroun' }, { id: '35', name: 'Canada' }, { id: '36', name: 'Cap-Vert' }, { id: '37', name: 'République centrafricaine' }, { id: '38', name: 'Chili' }, { id: '39', name: 'Chine' }, { id: '40', name: 'Chypre' }, { id: '41', name: 'Colombie' }, { id: '42', name: 'Comores' }, { id: '43', name: 'République démocratique du Congo' }, { id: '44', name: 'Congo' }, { id: '45', name: 'Corée du Nord' }, { id: '46', name: 'Corée du Sud' }, { id: '47', name: 'Costa Rica' }, { id: '48', name: 'Côte d\'Ivoire' }, { id: '49', name: 'Croatie' }, { id: '50', name: 'Cuba' }, { id: '51', name: 'Danemark' }, { id: '52', name: 'Djibouti' }, { id: '53', name: 'République dominicaine' }, { id: '54', name: 'Dominique' }, { id: '55', name: 'Égypte' }, { id: '56', name: 'Émirats arabes unis' }, { id: '57', name: 'Équateur' }, { id: '58', name: 'Érythrée' }, { id: '59', name: 'Espagne' }, { id: '60', name: 'Estonie' }, { id: '61', name: 'États-Unis' }, { id: '62', name: 'Éthiopie' }, { id: '63', name: 'Fidji' }, { id: '64', name: 'Finlande' }, { id: '65', name: 'France' }, { id: '66', name: 'Gabon' }, { id: '67', name: 'Gambie' }, { id: '68', name: 'Géorgie' }, { id: '69', name: 'Ghana' }, { id: '70', name: 'Grèce' }, { id: '71', name: 'Grenade' }, { id: '72', name: 'Guatemala' }, { id: '73', name: 'Guinée' }, { id: '74', name: 'Guinée-Bissau' }, { id: '75', name: 'Guinée équatoriale' }, { id: '76', name: 'Guyana' }, { id: '77', name: 'Haïti' }, { id: '78', name: 'Honduras' }, { id: '79', name: 'Hongrie' }, { id: '80', name: 'Inde' }, { id: '81', name: 'Indonésie' }, { id: '82', name: 'Irak' }, { id: '83', name: 'Iran' }, { id: '84', name: 'Irlande' }, { id: '85', name: 'Islande' }, { id: '86', name: 'Israël' }, { id: '87', name: 'Italie' }, { id: '88', name: 'Jamaïque' }, { id: '89', name: 'Japon' }, { id: '90', name: 'Jordanie' }, { id: '91', name: 'Kazakhstan' }, { id: '92', name: 'Kenya' }, { id: '93', name: 'Kirghizstan' }, { id: '94', name: 'Kiribati' }, { id: '95', name: 'Koweït' }, { id: '96', name: 'Laos' }, { id: '97', name: 'Lesotho' }, { id: '98', name: 'Lettonie' }, { id: '99', name: 'Liban' }, { id: '100', name: 'Liberia' }, { id: '101', name: 'Libye' }, { id: '102', name: 'Liechtenstein' }, { id: '103', name: 'Lituanie' }, { id: '104', name: 'Luxembourg' }, { id: '105', name: 'Macédoine' }, { id: '106', name: 'Madagascar' }, { id: '107', name: 'Malaisie' }, { id: '108', name: 'Malawi' }, { id: '109', name: 'Maldives' }, { id: '110', name: 'Mali' }, { id: '111', name: 'Malte' }, { id: '112', name: 'Maroc' }, { id: '113', name: 'Marshall' }, { id: '114', name: 'Maurice' }, { id: '115', name: 'Mauritanie' }, { id: '116', name: 'Mexique' }, { id: '117', name: 'Micronésie' }, { id: '118', name: 'Moldavie' }, { id: '119', name: 'Monaco' }, { id: '120', name: 'Mongolie' }, { id: '121', name: 'Mozambique' }, { id: '122', name: 'Namibie' }, { id: '123', name: 'Nauru' }, { id: '124', name: 'Népal' }, { id: '125', name: 'Nicaragua' }, { id: '126', name: 'Niger' }, { id: '127', name: 'Nigeria' }, { id: '128', name: 'Norvège' }, { id: '129', name: 'Nouvelle-Zélande' }, { id: '130', name: 'Oman' }, { id: '131', name: 'Ouganda' }, { id: '132', name: 'Ouzbékistan' }, { id: '133', name: 'Pakistan' }, { id: '134', name: 'Palaos' }, { id: '135', name: 'Panama' }, { id: '136', name: 'Papouasie-Nouvelle-Guinée' }, { id: '137', name: 'Paraguay' }, { id: '138', name: 'Pays-Bas' }, { id: '139', name: 'Pérou' }, { id: '140', name: 'Philippines' }, { id: '141', name: 'Pologne' }, { id: '142', name: 'Portugal' }, { id: '143', name: 'Qatar' }, { id: '144', name: 'Roumanie' }, { id: '145', name: 'Royaume-Uni' }, { id: '146', name: 'Russie' }, { id: '147', name: 'Rwanda' }, { id: '148', name: 'Saint-Christophe-et-Niévès' }, { id: '149', name: 'Sainte-Lucie' }, { id: '150', name: 'Saint-Marin' }, { id: '151', name: 'Saint-Siège' }, { id: '152', name: 'Saint-Vincent-et-les-Grenadines' }, { id: '153', name: 'Salomon' }, { id: '154', name: 'Salvador' }, { id: '155', name: 'Samoa' }, { id: '156', name: 'Sao Tomé-et-Principe' }, { id: '157', name: 'Sénégal' }, { id: '158', name: 'Serbie-et-Monténégro' }, { id: '159', name: 'Seychelles' }, { id: '160', name: 'Sierra Leone' }, { id: '161', name: 'Singapour' }, { id: '162', name: 'Slovaquie' }, { id: '163', name: 'Slovénie' }, { id: '164', name: 'Somalie' }, { id: '165', name: 'Soudan' }, { id: '166', name: 'Sri Lanka' }, { id: '167', name: 'Suède' }, { id: '168', name: 'Suisse' }, { id: '169', name: 'Suriname' }, { id: '170', name: 'Swaziland' }, { id: '171', name: 'Syrie' }, { id: '172', name: 'Tadjikistan' }, { id: '173', name: 'Tanzanie' }, { id: '174', name: 'Tchad' }, { id: '175', name: 'République tchèque' }, { id: '176', name: 'Thaïlande' }, { id: '177', name: 'Timor oriental' }, { id: '178', name: 'Togo' }, { id: '179', name: 'Tonga' }, { id: '180', name: 'Trinité-et-Tobago' }, { id: '181', name: 'Tunisie' }, { id: '182', name: 'Turkménistan' }, { id: '183', name: 'Turquie' }, { id: '184', name: 'Tuvalu' }, { id: '185', name: 'Ukraine' }, { id: '186', name: 'Uruguay' }, { id: '187', name: 'Vanuatu' }, { id: '188', name: 'Venezuela' }, { id: '189', name: 'Viêt Nam' }, { id: '190', name: 'Yémen' }, { id: '191', name: 'Zambie' }, { id: '192', name: 'Zimbabwe' }];
  cov_2l9qebrzd7.s[7]++;
  $scope.doughnutOptions = {
    segmentShowStroke: true,
    segmentStrokeColor: '#fff',
    segmentStrokeWidth: 2,
    percentageInnerCutout: 45, // This is 0 for Pie charts
    animationSteps: 100,
    animationEasing: 'easeOutBounce',
    animateRotate: true,
    animateScale: false
  };
  cov_2l9qebrzd7.s[8]++;
  $scope.error = {};
  cov_2l9qebrzd7.s[9]++;
  $scope.getAll = function () {
    cov_2l9qebrzd7.f[2]++;

    var toda = (cov_2l9qebrzd7.s[10]++, Date.newDate());
    cov_2l9qebrzd7.s[11]++;
    $scope.isloading = true;
    cov_2l9qebrzd7.s[12]++;
    $CRUDService.getAll($scope.PATH, { get: 'all' }, function (data) {
      cov_2l9qebrzd7.f[3]++;
      cov_2l9qebrzd7.s[13]++;

      for (var i = 0; i < data.length; i++) {
        cov_2l9qebrzd7.s[14]++;

        data[i].img = $deltahttp.getProjectRespositoy() + data[i].id + '.jpg?' + Date.newDate();
        cov_2l9qebrzd7.s[15]++;
        data[i].DATE_DEB_PROJET = Date.newDate(data[i].DATE_DEB_PROJET);
        cov_2l9qebrzd7.s[16]++;
        data[i].COUT = eval(data[i].COUT);
        cov_2l9qebrzd7.s[17]++;
        data[i].DATE_FIN_PROJET = Date.newDate(data[i].DATE_FIN_PROJET);
        cov_2l9qebrzd7.s[18]++;
        data[i].DATE_MI_PRO = Date.newDate((cov_2l9qebrzd7.b[1][0]++, data[i].DATE_MI_PRO) || (cov_2l9qebrzd7.b[1][1]++, undefined));
        var diff = (cov_2l9qebrzd7.s[19]++, data[i].DATE_FIN_PROJET - data[i].DATE_DEB_PROJET);
        cov_2l9qebrzd7.s[20]++;
        data[i].progress = 0;
        cov_2l9qebrzd7.s[21]++;
        if (diff != 0) {
          cov_2l9qebrzd7.b[2][0]++;
          cov_2l9qebrzd7.s[22]++;

          data[i].progress = Math.min((toda - data[i].DATE_DEB_PROJET) / diff * 100, 100);
        } else {
          cov_2l9qebrzd7.b[2][1]++;
        }
        cov_2l9qebrzd7.s[23]++;
        if (data[i].progress < 0) {
          cov_2l9qebrzd7.b[3][0]++;
          cov_2l9qebrzd7.s[24]++;

          data[i].progress = 0;
        } else {
          cov_2l9qebrzd7.b[3][1]++;
        }
        cov_2l9qebrzd7.s[25]++;
        data[i].progress = {
          data: [{
            value: data[i].progress,
            highlight: '#1ab394',
            label: '',
            color: '#1ab394'
          }, {
            value: 100 - data[i].progress,
            highlight: '#d7d7d7',
            label: '',
            color: '#d7d7d7'
          }]
        };
      }
      cov_2l9qebrzd7.s[26]++;
      $scope.isloading = false;
      cov_2l9qebrzd7.s[27]++;
      $scope.listProjects = data;

      cov_2l9qebrzd7.s[28]++;
      if (!$deltahttp.isProjectSelected()) {
        cov_2l9qebrzd7.b[4][0]++;
        cov_2l9qebrzd7.s[29]++;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = $scope.listProjects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var el = _step.value;
            cov_2l9qebrzd7.s[30]++;

            if ($rootScope.initProjet == el.id) {
              cov_2l9qebrzd7.b[5][0]++;
              cov_2l9qebrzd7.s[31]++;

              return $scope.select(el.id);
            } else {
              cov_2l9qebrzd7.b[5][1]++;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        cov_2l9qebrzd7.s[32]++;
        if ($scope.listProjects.length > 0) {
          cov_2l9qebrzd7.b[6][0]++;
          cov_2l9qebrzd7.s[33]++;

          return $scope.select($scope.listProjects[0].id);
        } else {
          cov_2l9qebrzd7.b[6][1]++;
        }
      } else {
        cov_2l9qebrzd7.b[4][1]++;
      }
      cov_2l9qebrzd7.s[34]++;
      $scope.visible = true;
    });
  };
  cov_2l9qebrzd7.s[35]++;
  $scope.selectedItem = {};
  cov_2l9qebrzd7.s[36]++;
  $scope.cancel = function () {
    cov_2l9qebrzd7.f[4]++;
    cov_2l9qebrzd7.s[37]++;

    $scope.isedit = false;
    cov_2l9qebrzd7.s[38]++;
    $scope.isadd = false;
  };
  cov_2l9qebrzd7.s[39]++;
  $scope.validate = function () {
    cov_2l9qebrzd7.f[5]++;
    cov_2l9qebrzd7.s[40]++;

    if ($scope.edit.tab == 1) {
      cov_2l9qebrzd7.b[7][0]++;
      cov_2l9qebrzd7.s[41]++;

      $scope.edit.tab = 2;
      cov_2l9qebrzd7.s[42]++;
      return;
    } else {
      cov_2l9qebrzd7.b[7][1]++;
    }
    var error = (cov_2l9qebrzd7.s[43]++, '');
    var validateItem = (cov_2l9qebrzd7.s[44]++, {
      ADR_PROJET: $scope.selectedItem.ADR_PROJET,
      AG_EXE_PROJET: $scope.selectedItem.AG_EXE_PROJET,
      CODE_ESPACE: $scope.selectedItem.CODE_ESPACE,
      CODE_PRJ: $scope.selectedItem.CODE_PRJ,
      DESCRIPTION_PROJET: $scope.selectedItem.DESCRIPTION_PROJET,
      EMAIL_PROJET: $scope.selectedItem.EMAIL_PROJET,
      DATE_DEB_PROJET: $deltadate.format($scope.selectedItem.DATE_DEB_PROJET, 'dd/mm/yyyy'),
      DATE_FIN_PROJET: $deltadate.format($scope.selectedItem.DATE_FIN_PROJET, 'dd/mm/yyyy'),
      DATE_MI_PRO: $deltadate.format($scope.selectedItem.DATE_MI_PRO, 'yyyy-mm-dd'),
      Format_cout: $scope.selectedItem.Format_cout,
      LIBELLE_PROJET: $scope.selectedItem.LIBELLE_PROJET,
      PAYS_PROJET: $scope.selectedItem.PAYS_PROJET.id,
      TEL_PROJET: $scope.selectedItem.TEL_PROJET,
      FAX_PROJET: $scope.selectedItem.FAX_PROJET,
      id: $scope.selectedItem.id,
      OBJECTIF: $scope.selectedItem.OBJECTIF,
      CIBLE: $scope.selectedItem.CIBLE,
      ZONE: $scope.selectedItem.ZONE,
      STATUT: $scope.selectedItem.STATUT,
      FINAN: $scope.selectedItem.FINAN,
      COUT: $scope.selectedItem.COUT
    });
    cov_2l9qebrzd7.s[45]++;
    $scope.error_code = false;
    cov_2l9qebrzd7.s[46]++;
    for (var i = 0; i < $scope.listProjects.length; i++) {
      var item = (cov_2l9qebrzd7.s[47]++, $scope.listProjects[i]);
      cov_2l9qebrzd7.s[48]++;
      if ($scope.listProjects[i].id == item.id) {
        cov_2l9qebrzd7.b[8][0]++;
        cov_2l9qebrzd7.s[49]++;

        // Verification doublons
        if ((cov_2l9qebrzd7.b[10][0]++, item.id != validateItem.id) && (cov_2l9qebrzd7.b[10][1]++, validateItem.CODE_PRJ == item.CODE_PRJ)) {
          cov_2l9qebrzd7.b[9][0]++;
          cov_2l9qebrzd7.s[50]++;

          error = 1;
          cov_2l9qebrzd7.s[51]++;
          $scope.error_code = true;
          cov_2l9qebrzd7.s[52]++;
          return;
        } else {
          cov_2l9qebrzd7.b[9][1]++;
        }
      } else {
        cov_2l9qebrzd7.b[8][1]++;
      }
    }
    cov_2l9qebrzd7.s[53]++;
    if ($scope.selectedItem.DATE_DEB_PROJET >= $scope.selectedItem.DATE_FIN_PROJET) {
      cov_2l9qebrzd7.b[11][0]++;
      cov_2l9qebrzd7.s[54]++;

      return;
    } else {
      cov_2l9qebrzd7.b[11][1]++;
    }
    var valueP = (cov_2l9qebrzd7.s[55]++, $filter('json')(validateItem, 3));

    cov_2l9qebrzd7.s[56]++;
    $scope.isloading = true;
    cov_2l9qebrzd7.s[57]++;
    $CRUDService.save($scope.PATH, { action: 'miseAJourAdmin', valeur: $filter('json')(validateItem) }, function (data) {
      cov_2l9qebrzd7.f[6]++;
      cov_2l9qebrzd7.s[58]++;

      $scope.cancel();
      cov_2l9qebrzd7.s[59]++;
      $scope.listProjects = $filter('orderBy')($scope.listProjects, 'CODE_PRJ');
      cov_2l9qebrzd7.s[60]++;
      $scope.getAll();
    });
  };
  cov_2l9qebrzd7.s[61]++;
  $scope.edit = function (id) {
    cov_2l9qebrzd7.f[7]++;
    cov_2l9qebrzd7.s[62]++;

    $scope.error_code = false;
    cov_2l9qebrzd7.s[63]++;
    $scope.isadd = true;
    cov_2l9qebrzd7.s[64]++;
    $scope.selectedItem = {
      ADR_PROJET: '',
      AG_EXE_PROJET: '',
      CODE_ESPACE: '',
      CODE_PRJ: '',
      DATE_DEB_PROJET: Date.newDate(),
      DATE_FIN_PROJET: Date.newDate(),
      DESCRIPTION_PROJET: '',
      Format_cout: '',
      LIBELLE_PROJET: '',
      PAYS_PROJET: $scope.contries[47],
      FAX_PROJET: '',
      EMAIL_PROJET: '',
      TEL_PROJET: '',
      id: 0,
      OBJECTIF: '',
      CIBLE: '',
      ZONE: '',
      STATUT: 0,
      DATE_MI_PRO: Date.newDate(),
      FINAN: '',
      COUT: 0

    };

    cov_2l9qebrzd7.s[65]++;
    if (id) {
      cov_2l9qebrzd7.b[12][0]++;
      cov_2l9qebrzd7.s[66]++;

      for (var i = 0; i < $scope.listProjects.length; i++) {
        cov_2l9qebrzd7.s[67]++;

        if ($scope.listProjects[i].id == id) {
          cov_2l9qebrzd7.b[13][0]++;

          var item = (cov_2l9qebrzd7.s[68]++, $scope.listProjects[i]);
          cov_2l9qebrzd7.s[69]++;
          if (item.id == id) {
            cov_2l9qebrzd7.b[14][0]++;
            cov_2l9qebrzd7.s[70]++;

            $scope.isedit = true;
            cov_2l9qebrzd7.s[71]++;
            $scope.selectedItem = {
              ADR_PROJET: item.ADR_PROJET,
              AG_EXE_PROJET: item.AG_EXE_PROJET,
              CODE_ESPACE: item.CODE_ESPACE,
              CODE_PRJ: item.CODE_PRJ,
              DATE_DEB_PROJET: item.DATE_DEB_PROJET,
              DATE_FIN_PROJET: item.DATE_FIN_PROJET,
              DESCRIPTION_PROJET: item.DESCRIPTION_PROJET,
              EMAIL_PROJET: item.EMAIL_PROJET,
              Format_cout: item.Format_cout,
              LIBELLE_PROJET: item.LIBELLE_PROJET,
              PAYS_PROJET: $scope.contries[item.PAYS_PROJET - 1],
              TEL_PROJET: item.TEL_PROJET,
              FAX_PROJET: item.FAX_PROJET,
              id: item.id,
              OBJECTIF: item.OBJECTIF,
              CIBLE: item.CIBLE,
              ZONE: item.ZONE,
              STATUT: item.STATUT,
              DATE_MI_PRO: item.DATE_MI_PRO,
              FINAN: item.FINAN,
              COUT: item.COUT
            };
            cov_2l9qebrzd7.s[72]++;
            break;
          } else {
            cov_2l9qebrzd7.b[14][1]++;
          }
        } else {
          cov_2l9qebrzd7.b[13][1]++;
        }
      }
    } else {
      cov_2l9qebrzd7.b[12][1]++;
    }
    cov_2l9qebrzd7.s[73]++;
    $scope.isedit = $scope.selectedItem.id == 0;
  };

  cov_2l9qebrzd7.s[74]++;
  $scope.deleteItem = function (item) {
    cov_2l9qebrzd7.f[8]++;
    cov_2l9qebrzd7.s[75]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('PROJECT.CONFIRM_DELETE'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2l9qebrzd7.f[9]++;
      cov_2l9qebrzd7.s[76]++;

      if (!isconfirm) {
        cov_2l9qebrzd7.b[15][0]++;
        cov_2l9qebrzd7.s[77]++;

        return;
      } else {
        cov_2l9qebrzd7.b[15][1]++;
      }
      cov_2l9qebrzd7.s[78]++;
      $scope.isloading = true;
      var validateItem = (cov_2l9qebrzd7.s[79]++, {
        ADR_PROJET: item.ADR_PROJET,
        AG_EXE_PROJET: item.AG_EXE_PROJET,
        CODE_ESPACE: item.CODE_ESPACE,
        CODE_PRJ: item.CODE_PRJ,
        DESCRIPTION_PROJET: item.DESCRIPTION_PROJET,
        EMAIL_PROJET: item.EMAIL_PROJET,
        DATE_DEB_PROJET: $deltadate.format(item.DATE_DEB_PROJET, 'dd/mm/yyyy'),
        DATE_FIN_PROJET: $deltadate.format(item.DATE_FIN_PROJET, 'dd/mm/yyyy'),
        Format_cout: item.Format_cout,
        LIBELLE_PROJET: item.LIBELLE_PROJET,
        PAYS_PROJET: item.PAYS_PROJET.id,
        TEL_PROJET: item.TEL_PROJET,
        FAX_PROJET: item.FAX_PROJET,

        id: item.id
      });
      cov_2l9qebrzd7.s[80]++;
      $CRUDService.delet($scope.PATH, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_2l9qebrzd7.f[10]++;
        cov_2l9qebrzd7.s[81]++;

        if (data < 0) {
          cov_2l9qebrzd7.b[16][0]++;
          cov_2l9qebrzd7.s[82]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_2l9qebrzd7.s[83]++;
          $scope.isloading = false;
          cov_2l9qebrzd7.s[84]++;
          return;
        } else {
          cov_2l9qebrzd7.b[16][1]++;
        }
        cov_2l9qebrzd7.s[85]++;
        $scope.getAll();
      });
    });
  };
  cov_2l9qebrzd7.s[86]++;
  $scope.select = function (idp) {
    cov_2l9qebrzd7.f[11]++;

    var selectedProjet = (cov_2l9qebrzd7.s[87]++, null);
    cov_2l9qebrzd7.s[88]++;
    for (var i = 0; i < $scope.listProjects.length; i++) {
      cov_2l9qebrzd7.s[89]++;

      if ($scope.listProjects[i].id == idp) {
        cov_2l9qebrzd7.b[17][0]++;
        cov_2l9qebrzd7.s[90]++;

        selectedProjet = $scope.listProjects[i];
        cov_2l9qebrzd7.s[91]++;
        break;
      } else {
        cov_2l9qebrzd7.b[17][1]++;
      }
    }
    cov_2l9qebrzd7.s[92]++;
    $otherHttpService.post($scope.PATH, { action: 'setActive', id: idp }, function (data) {
      cov_2l9qebrzd7.f[12]++;
      cov_2l9qebrzd7.s[93]++;

      $rootScope.setProject({
        project: selectedProjet,
        droit: data.droits,
        connected: data.connect,
        link: data.a,
        admin: data.res
      });
      cov_2l9qebrzd7.s[94]++;
      $deltaclearData.clearData();

      cov_2l9qebrzd7.s[95]++;
      $location.path('/app/dashboard').replace();
    });
  };
  var uploader = (cov_2l9qebrzd7.s[96]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'data/web_server.php?action=img&method=1&' + $CRUDService.getComplement(0, $scope.PATH),
    alias: 'fileformatrapp',
    removeAfterUpload: true
  }));
  cov_2l9qebrzd7.s[97]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_2l9qebrzd7.f[13]++;
    cov_2l9qebrzd7.s[98]++;

    fileItem.url = uploader.url + '&id=' + fileItem.p;
    cov_2l9qebrzd7.s[99]++;
    $scope.isloading = true;
    cov_2l9qebrzd7.s[100]++;
    fileItem.upload();
  };
  cov_2l9qebrzd7.s[101]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_2l9qebrzd7.f[14]++;
    cov_2l9qebrzd7.s[102]++;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = $scope.listProjects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var el = _step2.value;
        cov_2l9qebrzd7.s[103]++;

        if (el.id == fileItem.p) {
          cov_2l9qebrzd7.b[18][0]++;
          cov_2l9qebrzd7.s[104]++;

          el.img = $deltahttp.getProjectRespositoy() + el.id + '.jpg?' + Date.newDate();
          cov_2l9qebrzd7.s[105]++;
          break;
        } else {
          cov_2l9qebrzd7.b[18][1]++;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    cov_2l9qebrzd7.s[106]++;
    $scope.isloading = false;
  };
  cov_2l9qebrzd7.s[107]++;
  $scope.getAll();
});